module.exports = __webpack_public_path__ + "static/media/banorte_white.1487feeb.svg";